export default __webpack_public_path__ + "static/media/edit-active.67c71b80.svg";